import React, { useState, useEffect } from "react";
import { useParams, useNavigate , useOutletContext, useLocation } from "react-router-dom";
import { usePatient } from "../../context/PatientContext";
import PatientSymptomsForm from "../Forms/PatientSymptomsForm";
import { useAuth } from "../../context/AuthProvider";

const EditPatientSymptoms = () => {
    const {patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
    const { patientId, caseId, visitId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { markSectionComplete } = useOutletContext() ;  
      const { verifyTokenAndRedirect } = useAuth();
    const location = useLocation();
    useEffect(() => {
        verifyTokenAndRedirect();
        if (!patientData && !patientId && !caseId && !visitId) {
            setPatientData({
              PATIENT_ID: null,
              CASE_ID: null,
              VISIT_ID: null,
              patientSymptoms: [{}],
              // other sections can be added here too
            });
          }
    }, []);


    const onSubmitHandler = (updatedSymptoms) => {

        console.log('patientData in edit patient symptoms submit handler', patientData);
   
    const updatedData = {
        ...patientData,
        patientSymptoms: patientData?.patientSymptoms?.length > 0 
            ? patientData.patientSymptoms.map(info => ({
                ...info, // Keep existing patientInfo fields
                ...updatedSymptoms, // Merge updated fields
                PATIENT_ID: patientData.PATIENT_ID, 
                CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
                VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
                DOCTOR_ID: doctorInfo.MANDALI_ID,
                CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
        
            }))
            : [{
                ...updatedSymptoms, 
                PATIENT_ID: patientData.PATIENT_ID,
                CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
                VISIT_ID: selectedVisit|| visitId, // Default VISIT_ID if not provided
                DOCTOR_ID: doctorInfo.MANDALI_ID,
                CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
        
            }]
    };



     setPatientData(updatedData);
     markSectionComplete("symptoms");
     if (location.pathname.startsWith("/addpatient")) {
        navigate("/addpatient/history");
      } else if (location.pathname.startsWith("/visits")) {
        navigate(`/visits/${patientId}/${caseId}/${visitId}/history`);
      } else {
        console.warn("Unknown route, no redirection");
      }
    };

    if (loading) return <div>Loading symptoms data...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
        {patientData || (patientId === undefined && caseId === undefined && visitId === undefined) ?  (
          <PatientSymptomsForm
            initialValues={{
              ...patientData,
              patientSymptoms: patientData?.patientSymptoms || [{}] // default fallback
            }}
            onSubmit={onSubmitHandler}
            enableReinitialize={true}
          />
        ) : (
          <div>Loading patient data...</div>
        )}
        </div>
    );
};

export default EditPatientSymptoms;
